module.exports = __webpack_public_path__ + "../resources/img/img_ef_layer2_offgrid_no-inverter-no-pv 1.bf982a49.svg";